import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hb-small-action-button',
  templateUrl: './small-action-button.component.html',
  styleUrls: ['./small-action-button.component.scss'],
})
export class SmallActionButtonComponent {
  @Input() title: string;
  @Input() showTitleAsLabel: boolean = false;
  @Input() icon: string = 'plus';
  @Input() largeIcon: boolean = false;
  @Input() buttonId: string;
  @Input() buttonClasses: string = '';
  @Input() buttonType: string = 'button';
  @Input() buttonStyles;
  @Input() isToggleButton: boolean = false;
  @Input() toggleState: boolean = false;
  @Input() padIcon: boolean = true;
  @Input() disabled: boolean = false;
  @Input() floatRight: boolean = true;
  @Input() display: boolean = true;
  @Output() clickEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
